import { useTracking } from 'react-tracking';

import { useUserAgent } from '@simplywallst/hooks/useUserAgent';
import { useIsMobileScreen } from '@/hooks/useMedia';
import Carousel from '@/components/Carousel';
import { StyledEmbla } from '@/components/Carousel/styled';
import { NarrativeCardPopulated } from '@/components/NarrativeCard';

import { useNarrativeWeeklyPicks } from '../../hooks/useNarrativeWeeklyPicks';
import { NarrativeInvalidationBoundary } from '../../../NarrativeInvalidationBoundary';
import { handleOnSetPrimary } from '../../utils';

export const NarrativeCommunitySpotlightList = () => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });
  const { trackEvent } = useTracking();
  const { data } = useNarrativeWeeklyPicks();
  const narratives = data?.narrativeWeeklyPicks ?? [];
  const hasMoreThanOneNarrative = narratives.length > 1;

  const handleOnClick = (narrative: (typeof narratives)[number]) => {
    const { id, company } = narrative;
    return trackEvent({
      action: 'click',
      modifier: 'view',
      narrativeId: id,
      companyId: company?.id,
      uniqueSymbol: company?.tickerSymbol,
    });
  };

  if (narratives.length === 0) {
    return null;
  }

  return (
    <section className="my-x2 grid w-full overflow-hidden">
      <h2 className="m-0 mb-2 text-sm font-medium text-solid">Weekly Picks</h2>
      <div className="-mt-x2 grid">
        <NarrativeInvalidationBoundary
          onSetPrimary={handleOnSetPrimary(
            useNarrativeWeeklyPicks.getOptions({}).queryKey
          )}
        >
          <StyledEmbla className="mt-x2">
            <Carousel
              align="center"
              containScroll="trimSnaps"
              showArrows={hasMoreThanOneNarrative}
              showGradient={hasMoreThanOneNarrative}
              slidesToScroll={isMobileScreen ? 1 : 2}
            >
              <div
                role="list"
                className="grid w-full gap-x1"
                style={{
                  gridTemplateColumns: hasMoreThanOneNarrative
                    ? `repeat(${narratives.length}, 317px)`
                    : 'minmax(317px,500px)',
                }}
              >
                {narratives.map((narrative) => (
                  <div role="listitem" key={narrative.id}>
                    <NarrativeCardPopulated
                      showCompanyIcon
                      narrative={narrative}
                      onClick={() => handleOnClick(narrative)}
                      titleAs="h3"
                    />
                  </div>
                ))}
              </div>
            </Carousel>
          </StyledEmbla>
        </NarrativeInvalidationBoundary>
      </div>
    </section>
  );
};
